import { render } from "./allQuriesForAlert.vue?vue&type=template&id=3f8372b8"
import script from "./allQuriesForAlert.vue?vue&type=script&lang=js"
export * from "./allQuriesForAlert.vue?vue&type=script&lang=js"

import "./allQuriesForAlert.vue?vue&type=style&index=0&id=3f8372b8&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__